import React from 'react';

const ArrowDownIcon = () => (
  <svg
    width='11'
    height='6'
    viewBox='0 0 11 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.5 0.0625H10.5C10.5866 0.0624319 10.6721 0.0876736 10.7441 0.135742C10.8161 0.183806 10.8722 0.253074 10.9053 0.333008C10.9382 0.412719 10.9464 0.500366 10.9297 0.584961C10.917 0.648598 10.8909 0.709041 10.8525 0.760742L10.8096 0.80957L5.80957 5.80957C5.76901 5.85014 5.72096 5.88231 5.66797 5.9043C5.61486 5.92631 5.55749 5.9375 5.5 5.9375C5.44265 5.93745 5.38599 5.92625 5.33301 5.9043C5.3064 5.89327 5.28066 5.8802 5.25684 5.86426L5.19043 5.80957L0.19043 0.80957L0.148438 0.760742C0.110078 0.709021 0.0839693 0.648635 0.0712891 0.584961C0.0545174 0.500331 0.0627671 0.412748 0.0957031 0.333008C0.128843 0.253026 0.18483 0.18381 0.256836 0.135742C0.32875 0.0877375 0.413541 0.0625 0.5 0.0625Z'
      fill='#53555F'
      stroke='#53555F'
      strokeWidth='0.125'
    />
  </svg>
);

export default ArrowDownIcon;
